import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.imgUrl != null)
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "accordion__image",
        src: _ctx.imgUrl,
        alt: "img",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openImage && _ctx.openImage(...args))),
        "object-fit": "cover"
      }, null, 8, _hoisted_1))
    : _createCommentVNode("", true)
}